import { DeferredUpdater, profiler } from '@dinosband/dbi-utils'
import { Message } from './types'
import { MessageMemCache } from './message-mem-cache'
import { MessageCacheIndexedDBDriver } from './message-cache-indexed-db-driver'
// import { MessageCacheIndexedDBWorkerDriver as MessageCacheIndexedDBDriver } from './message-cache-indexed-db-worker-driver'

const CHATROOM_ID = 1 // use this chatRoomId instead of each message's

//--------------------------------------------------------------------------
// MessageCacheSingle
//--------------------------------------------------------------------------
export class MessageCacheSingle {
  protected _isLoaded = false
  protected dbName: string
  protected maxCount: number
  protected cache: MessageMemCache
  protected db: MessageCacheIndexedDBDriver
  protected updater: DeferredUpdater

  constructor (dbName: string, maxCount: number, updateDelay = 3000) {
    this.dbName = dbName
    this.maxCount = maxCount
    this.cache = new MessageMemCache()
    this.db = new MessageCacheIndexedDBDriver(dbName)
    this.updater = new DeferredUpdater(async () => {
      await this.flush()
    }, updateDelay)
  }

  get isLoaded () {
    return this._isLoaded
  }

  async load () {
    profiler.of(this.dbName + '.load').begin()
    const mesgs = await this.db.load(CHATROOM_ID)
    await this.cache.load(mesgs)
    this._isLoaded = true
    profiler.of(this.dbName + '.load').end()
  }

  async reset (): Promise<void> {
    this.cache.reset()
    await this.db.reset()
  }

  readBulkByIds (ids: number[]): Message[] {
    return ids.map((i) => this.cache._read(i, true))
      .filter((i) => i) as Message[]
  }

  get (inMesg: Message, byId = false): Message | null {
    const cached = this.cache.get(inMesg, byId)
    if (cached) {
      if (cached.updatedAt === inMesg.updatedAt) {
        return cached
      } else {
        this.cache.delete(inMesg)
      }
    }
    return null
  }

  getById (messageId: number): Message | null {
    return this.cache.getById(messageId)
  }

  contents () {
    return this.cache.contents
  }

  put (mesg: Message): void {
    return this.bulkPut([mesg])
  }

  bulkPut (mesgs: Message[]): void {
    mesgs.forEach((mesg) => {
      if (!mesg.props) {
        console.error('cache/put', mesg.id, mesg.seq)
      }
      if (!mesg.seq) {
        console.error('cache/put', mesg.id, mesg.seq)
        return
      }
      const verifiedAt = Date.now()
      // const cached = cache.get(mesg)
      // if (cached) {
      //   if (cached.updatedAt === mesg.updatedAt && cached.props) {
      //     // console.error('cache/put (exist): ', chatRoomId, mesg.seq)
      //     return
      //   }
      // }
      this.cache.put({ ...mesg, verifiedAt })
      this.updater.touch()
    })
  }

  remove (mesg: Message): void {
    this.cache.delete(mesg)
    this.updater.touch()
  }

  async flush (): Promise<void> {
    profiler.of(this.dbName + '.flush').begin()
    // CAUTION: deleteOlds() should be called before getModified()
    const toDelete = this.cache.deleteOlds(this.maxCount)
    if (toDelete.length) {
    }
    if (toDelete.length) {
      await this.db.delete(toDelete)
    }

    const toPut = this.cache.getModified()
    if (toPut.length) {
    }
    if (toPut.length) {
      this.cache.setSaved(toPut)
      await this.db.put(toPut, CHATROOM_ID)
    }
    profiler.of(this.dbName + '.flush').end()
  }
}
